import  { AppError } from '~/exceptions/app.error';

export class StoreError extends AppError {

    constructor(clazz: string, message?: string, error?: Error) {
        super(clazz, message, error);
        this.stack = error?.stack;
    }
}

export class StationsStoreError extends StoreError {

    name = 'StationsStoreError';

    constructor(message?: string, error?: Error) {
        super('station-store', message, error);
        this.stack = error?.stack;
    }
}

export class DashboardStoreError extends StoreError {
    constructor(message: string, error?: Error) {
        super('dashboard-store', message, error);
        this.stack = error?.stack;
    }
}

export class DashboardStoreSocketError extends DashboardStoreError {
    constructor(message: string, error?: Error) {
        super(message, error);
        this.stack = error?.stack;
    }
}

export class StationDetailsStoreError extends StoreError {
    constructor(message: string, error?: Error) {
        super('station-details-store', message, error);
        this.stack = error?.stack;
    }
}

export class DispatchStoreError extends StoreError {
    constructor(message: string, error?: Error) {
        super('dashboard-store', message, error);
        this.stack = error?.stack;
    }
}

export class DispatchStoreSocketError extends DispatchStoreError {
    constructor(message: string, error?: Error) {
        super(message, error);
        this.stack = error?.stack;
    }
}
